// tslint:disable
/**
 * Speedtest Plus API
 * This is the API for Speedtest Plus
 *
 * The version of the OpenAPI document: 0.28.0
 * Contact: speedtest-api@anw.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface DeviceModel
 */
export interface DeviceModel {
    /**
     * Type of the client device.
     * @type {string}
     * @memberof DeviceModel
     */
    deviceType?: DeviceModelDeviceTypeEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum DeviceModelDeviceTypeEnum {
    Mobile = 'mobile',
    Tablet = 'tablet',
    Desktop = 'desktop',
    Settop = 'settop',
    Crawler = 'crawler'
}

